.WikiLoveMonuments {
  background-color: var(--overlay);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 10;
  padding: 32px 24px;
  overflow-y: auto;
}

.TopWikiLove {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--primary);
  border-bottom: 0.5px solid var(--primary);
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.WikiLoveLabel {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.TextWikiLove {
  color: var(--colori-neutri-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 100%;
  overflow-y: auto;
}

.TextWikiLove  p > a {
  color: var(--primary);
  font-family: var(--font-montserrat);
  font-weight: 700;
}

.TextWikiLove  p > strong {
  color: var(--primary);
  font-family: var(--font-montserrat);
  font-weight: 700;
}

.ButtonRivediTutorial {
  background: var(--primary);
  border-radius: 4px;
  padding: 8px 16px;
  color: var(--colori-neutri-white);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  width: max-content;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.ButtonRivediTutorial:hover {
  background: var(--secondary);
}
